import { css } from '@emotion/react';
import { ScrollBarStyle } from './ScrollBarStyle';

export const DropdownStyle = ({ noPadding }: { noPadding?: boolean } = { noPadding: false }) => css`
	background: #fff;
	box-shadow: 0 20px 32px -8px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0, 0, 0, 0.05);
	border-radius: 8px;

	padding: ${noPadding ? '0' : '6px 0'};

	max-height: 300px;
	overflow: auto;

	margin-top: 2px;

	${ScrollBarStyle()}
`;
